import type { AppStateAction } from './types';
import type { ReactNode } from 'react';

import { useMemo, useReducer, useRef } from 'react';

import { AppContext } from './context';
import { trackStepMiddleware } from './dispatch-middlewares';
import { appReducer, initialAppState } from './reducer';

export type AppProviderProps = {
  children?: ReactNode;
};

export const AppProvider = ({ children }: AppProviderProps) => {
  const [state, dispatch] = useReducer(appReducer, initialAppState);

  function dispatchWithMiddlewares(value: AppStateAction) {
    trackStepMiddleware(value);
    dispatch(value);
  }

  /**
   * Dispatch function does not point to the same reference on re-render.
   *
   * TODO: Check if there exists better solution or any approach.
   */
  const dispatchWithMiddlewaresRef = useRef(dispatchWithMiddlewares);

  const contextValue = useMemo(
    () => ({
      state,
      dispatch: dispatchWithMiddlewaresRef.current,
    }),
    [state, dispatchWithMiddlewaresRef],
  );

  return <AppContext.Provider value={contextValue}>{children}</AppContext.Provider>;
};
